import { PageRef } from 'providers/page-ref';

export type AppSettingsPageParams = {};

export const IAppSettingsPage: PageRef<AppSettingsPageParams, void> = {
  pageName: 'AppSettingsPage',
} as PageRef<AppSettingsPageParams, void>;
